module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/link_icon/link_fb-14fb7f5a0c08e53e4e003b205c326248.svg&quot;;"